import { useEffect, useState } from "react";
import { post } from "../networking/RequestService";

const useGetGptRecommendation = (queryProfileId) => {
    const [gptRecommendation, setGptRecommendation] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchProfile = async () => {
        if (!queryProfileId) return;

        setLoading(true);
        setError(null);
        try {
            const res = await post({
                fn: "getGptRecommendation",
                profileId: queryProfileId,
            });

            setGptRecommendation(res.data.data);
        } catch (err) {
            setError(err);
            //setProfile(null);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchProfile();
    }, [queryProfileId]);

    return { gptRecommendation, loading, error, refetch: fetchProfile };
};

export default useGetGptRecommendation;
